import * as WorkspaceAPI from "trimble-connect-workspace-api";

const MENU_COMMAND = "connect_blaxtair";

// Only true when the app is loaded as an extension inside Trimble Connect for Browser
function isInTrimbleConnect(): boolean {
  if (window.self === window.top) {
    return false;
  }
  // ancestorOrigins is not available in Firefox, the referrer is the fallback
  const parentOrigin = window.location.ancestorOrigins?.[0] || document.referrer;
  try {
    return new URL(parentOrigin).hostname.endsWith("connect.trimble.com");
  } catch {
    return false;
  }
}

// Registers the left navigation menu entry of the Trimble Connect project extension
export async function initTrimbleExtension() {
  if (!isInTrimbleConnect()) {
    return;
  }

  let api: WorkspaceAPI.WorkspaceAPI | undefined;
  try {
    api = await WorkspaceAPI.connect(
      window.parent,
      (event, args) => {
        if (event === "extension.command" && args.data === MENU_COMMAND) {
          api?.ui.setActiveMenuItem(MENU_COMMAND);
        }
      },
      30000,
    );

    await api.ui.setMenu({
      title: "Connect Blaxtair",
      icon: `${window.location.origin}/images/favicon.png`,
      command: MENU_COMMAND,
    });
  } catch (e) {
    console.error("Trimble Connect extension init failed", e);
  }
}
